export const questions = {
    js: [
        {
            filename: "sumFunction.js",
            lines: [
                "function sum(a, b) {",
                "  if (!a || !b) return 0;",
                "  return a + b;",
                "}",
                "console.log(sum(0, 5));"
            ],
            correct: 1,
        },

        {
            filename: "syntaxBug.js",
            lines: [
                "function greet(name) {",
                "  console.log('Hello ' + name);",
                "  greet('Alice';",
                "}"
            ],
            correct: 2,
        },

        {
            filename: "runtimeBug.js",
            lines: [
                "const arr = [1, 2, 3];",
                "console.log(arr[5].toString());",
            ],
            correct: 1,
        },

        {
            filename: "offByOne.js",
            lines: [
                "const nums = [10, 20, 30];",
                "for (let i = 0; i <= nums.length; i++) {",
                "  console.log(nums[i]);",
                "}"
            ],
            correct: 1,
        },

        {
            filename: "multiply.js",
            lines: [
                "function multiply(a, b) {",
                "  return a + b;",
                "}",
                "console.log(multiply(2, 3));"
            ],
            correct: 1,
        },

        // 6. Condition bug
        {
            filename: "conditionBug.js",
            lines: [
                "function isAdult(age) {",
                "  if (age > 18) return true;",
                "  return false;",
                "}"
            ],
            correct: 1,
        },
        {
            filename: "nullAccess.js",
            lines: [
                "let user = null;",
                "console.log(user.name);",
            ],
            correct: 1,
        },

        {
            filename: "objSyntax.js",
            lines: [
                "const person = {",
                "  name: 'Alice'",
                "  age: 25",
                "};"
            ],
            correct: 1,
        },
        {
            filename: "checkEven.js",
            lines: [
                "function isEven(num) {",
                "  return num % 2 == 1;",
                "}",
                "console.log(isEven(4));"
            ],
            correct: 1,
        },
        {
            filename: "sliceBug.js",
            lines: [
                "const letters = ['a','b','c','d'];",
                "const sub = letters.slice(0, 4);",
                "console.log(sub);"
            ],
            correct: 1,
        },
        {
            filename: "forLoop.js",
            lines: [
                "for (var i = 0; i <= nums.length; i++) {",
                "  console.log(nums[i]);",
                "const nums = [1, 2, 3, 4];",
                "}"
            ],
            correct: 0,
        },
        {
            filename: "filterEven.js",
            lines: [
                "console.log(evens);",
                "const nums = [1, 2, 3, 4, 5];",
                "const evens = nums.filter(n => n % 2);"
            ],
            correct: 2,
        },
        {
            filename: "counterBug.js",
            lines: [
                "console.log(increment);",
                "function increment() {",
                "  count++;",
                "  return count;",
                "let count = 0;",
                "console.log(increment());"
            ],
            correct: 0,
        },
        {
            filename: "arrayCopy.js",
            lines: [
                "const copy = arr;",
                "copy.push(4);",
                "console.log(arr);",
                "const arr = [1, 2, 3];",
            ],
            correct: 0,
        },
        {
            filename: "asyncWait.js",
            lines: [
                "async function fetchData() {",
                "  const data = fetch('/api');",
                "  return data.json();",
                "}",
            ],
            correct: 1,
        },
        {
            filename: "stringCompare.js",
            lines: [
                "if (user.name == 'alice') {",
                "  console.log('Welcome back!');",
                "const user = { name: 'Alice' };",
                "}",
            ],
            correct: 0,
        },
        {
            filename: "objectSpread.js",
            lines: [
                "clone.age = 30;",
                "const clone = user;",
                "console.log(user.age);",
                "const user = { name: 'Bob', age: 25 };",
            ],
            correct: 1,
        },
        {
            filename: "mapIndexBug.js",
            lines: [
                "const doubled = arr.map((n, i) => i * 2);",
                "console.log(doubled);",
                "const arr = [1, 2, 3];",
            ],
            correct: 0,
        },
        {
            filename: "reduceSum.js",
            lines: [
                "console.log(sum);",
                "const arr = [1, 2, 3];",
                "const sum = arr.reduce((a, b) => { a + b; }, 0);",
            ],
            correct: 2,
        },
        {
            filename: "timeoutLoop.js",
            lines: [
                "  setTimeout(() => console.log(i), 1000);",
                "for (var i = 0; i < 3; i++) {",
                "}",
            ],
            correct: 0,
        },
        {
            filename: "jsonBug.js",
            lines: [
                "console.log(JSON.parse(obj));",
                "const obj = { a: 1 };",
            ],
            correct: 0,
        },
        {
            filename: "filterReturn.js",
            lines: [
                "console.log(res);",
                "const arr = [1, 2, 3];",
                "const res = arr.filter(n => { n > 1 });",
            ],
            correct: 2,
        },
        {
            filename: "dateCompare.js",
            lines: [
                "if (a === b) console.log('Same!');",
                "const b = new Date('2020-01-02');",
                "const a = new Date('2020-01-01');",
            ],
            correct: 0,
        },
        {
            filename: "arraySort.js",
            lines: [
                "console.log(nums);",
                "nums.sort();",
                "const nums = [10, 2, 5];",
            ],
            correct: 1,
        },
        {
            filename: "setBug.js",
            lines: [
                "console.log(set.length);",
                "const set = new Set([1, 2, 2]);",
            ],
            correct: 0,
        },
        {
            filename: "findBug.js",
            lines: [
                "const users = [{name:'A'},{name:'B'}];",
                "console.log(u);",
                "const u = users.find(u => u.name = 'B');",
            ],
            correct: 2,
        },
        {
            filename: "includesBug.js",
            lines: [
                "if (str.includes('h')) console.log('yes');",
                "const str = 'Hello';",
            ],
            correct: 0,
        },
        {
            filename: "defaultParamBug.js",
            lines: [
                "function greet(name = 'Guest') {",
                "  return 'Hello ' + Name;",
                "}",
            ],
            correct: 1,
        },
        {
            filename: "typeofBug.js",
            lines: [
                "let n = 5;",
                "if (typeof n === Number) console.log('num');",
            ],
            correct: 1,
        },
    ],
    // js: [
    //     {
    //         filename: "sumFunction.js",
    //         lines: [
    //             "function sum(a, b) {",
    //             "  const valid = [a, b].every(n => typeof n === 'number');",
    //             "  if (!a || !b) return 0;",
    //             "  return a + b;",
    //             "}",
    //             "console.log(sum(0, 5));"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "syntaxBug.js",
    //         lines: [
    //             "function greet(name) {",
    //             "  const msg = 'Hello ' + name;",
    //             "  console.log(msg);",
    //             "}",
    //             "greet('Alice';"
    //         ],
    //         correct: 4,
    //     },

    //     {
    //         filename: "runtimeBug.js",
    //         lines: [
    //             "const arr = [1, 2, 3].map(n => n);",
    //             "const index = 5;",
    //             "console.log(arr[index].toString());",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "offByOne.js",
    //         lines: [
    //             "const nums = [10, 20, 30].filter(n => n > 0);",
    //             "for (let i = 0; i <= nums.length; i++) {",
    //             "  console.log(nums[i]);",
    //             "}"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "multiply.js",
    //         lines: [
    //             "function multiply(a, b) {",
    //             "  const result = a + b;",
    //             "  return result;",
    //             "}",
    //             "console.log(multiply(2, 3));"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "conditionBug.js",
    //         lines: [
    //             "function isAdult(age) {",
    //             "  const limit = 18;",
    //             "  if (age > limit) return true;",
    //             "  return false;",
    //             "}"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "nullAccess.js",
    //         lines: [
    //             "let user = null;",
    //             "const label = 'User name:';",
    //             "console.log(user.name);",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "objSyntax.js",
    //         lines: [
    //             "const person = {",
    //             "  name: 'Alice',",
    //             "  age: 25",
    //             "};"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "checkEven.js",
    //         lines: [
    //             "function isEven(num) {",
    //             "  const remainder = num % 2;",
    //             "  return remainder == 1;",
    //             "}",
    //             "console.log(isEven(4));"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "sliceBug.js",
    //         lines: [
    //             "const letters = ['a','b','c','d'].map(l => l);",
    //             "const endIndex = letters.length;",
    //             "const sub = letters.slice(0, endIndex);",
    //             "console.log(sub);"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "forLoop.js",
    //         lines: [
    //             "const nums = [1, 2, 3, 4].filter(n => n > 0);",
    //             "for (var i = 0; i <= nums.length; i++) {",
    //             "  console.log(nums[i]);",
    //             "}"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "filterEven.js",
    //         lines: [
    //             "const nums = [1, 2, 3, 4, 5].map(n => n);",
    //             "const evens = nums.filter(n => n % 2);",
    //             "console.log(evens);"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "counterBug.js",
    //         lines: [
    //             "let count = 0;",
    //             "function increment() {",
    //             "  count++;",
    //             "  return count;",
    //             "}",
    //             "console.log(increment);"
    //         ],
    //         correct: 5,
    //     },

    //     {
    //         filename: "arrayCopy.js",
    //         lines: [
    //             "const arr = [1, 2, 3].map(n => n);",
    //             "const copy = arr;",
    //             "copy.push(4);",
    //             "console.log(arr);"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "asyncWait.js",
    //         lines: [
    //             "async function fetchData() {",
    //             "  const response = fetch('/api');",
    //             "  return response.json();",
    //             "}"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "stringCompare.js",
    //         lines: [
    //             "const user = { name: 'Alice' };",
    //             "const input = 'alice'.toLowerCase();",
    //             "if (user.name == input) {",
    //             "  console.log('Welcome back!');",
    //             "}"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "objectSpread.js",
    //         lines: [
    //             "const user = { name: 'Bob', age: 25 };",
    //             "const clone = user;",
    //             "clone.age = 30;",
    //             "console.log(user.age);"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "mapIndexBug.js",
    //         lines: [
    //             "const arr = [1, 2, 3].map(n => n);",
    //             "const doubled = arr.map((n, i) => i * 2);",
    //             "console.log(doubled);"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "reduceSum.js",
    //         lines: [
    //             "const arr = [1, 2, 3].map(n => n);",
    //             "const sum = arr.reduce((a, b) => {",
    //             "  a + b;",
    //             "}, 0);",
    //             "console.log(sum);"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "timeoutLoop.js",
    //         lines: [
    //             "for (var i = 0; i < 3; i++) {",
    //             "  const delay = 1000;",
    //             "  setTimeout(() => console.log(i), delay);",
    //             "}"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "jsonBug.js",
    //         lines: [
    //             "const obj = { a: 1 };",
    //             "const json = JSON.stringify(obj);",
    //             "console.log(JSON.parse(obj));"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "filterReturn.js",
    //         lines: [
    //             "const arr = [1, 2, 3].map(n => n);",
    //             "const res = arr.filter(n => {",
    //             "  n > 1;",
    //             "});",
    //             "console.log(res);"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "dateCompare.js",
    //         lines: [
    //             "const a = new Date('2020-01-01');",
    //             "const b = new Date('2020-01-02');",
    //             "if (a === b) console.log('Same!');"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "arraySort.js",
    //         lines: [
    //             "const nums = [10, 2, 5].map(n => n);",
    //             "nums.sort();",
    //             "console.log(nums);"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "setBug.js",
    //         lines: [
    //             "const set = new Set([1, 2, 2]);",
    //             "const size = set.size;",
    //             "console.log(set.length);"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "findBug.js",
    //         lines: [
    //             "const users = [{name:'A'},{name:'B'}];",
    //             "const u = users.find(u => u.name = 'B');",
    //             "console.log(u);"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "includesBug.js",
    //         lines: [
    //             "const str = 'Hello'.toLowerCase();",
    //             "if (str.includes('h')) console.log('yes');"
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "defaultParamBug.js",
    //         lines: [
    //             "function greet(name = 'Guest') {",
    //             "  const label = 'Hello ';",
    //             "  return label + Name;",
    //             "}"
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "typeofBug.js",
    //         lines: [
    //             "let n = 5;",
    //             "const type = typeof n;",
    //             "if (type === Number) console.log('num');"
    //         ],
    //         correct: 2,
    //     },
    // ],
    // python: [
    //     {
    //         filename: "mutable_default.py",
    //         lines: [
    //             "def append_item(item, lst=[]):",
    //             "    value = item",
    //             "    lst.append(value)",
    //             "    total = len(lst)",
    //             "    return lst",
    //             "result1 = append_item(1)",
    //             "result2 = append_item(2)",
    //             "print(result2)",
    //         ],
    //         correct: 0,
    //     },

    //     {
    //         filename: "syntax_error.py",
    //         lines: [
    //             "def greet(name)",
    //             "    message = 'Hello ' + name",
    //             "    print(message)",
    //             "value = 'Alice'",
    //             "greet(value)",
    //         ],
    //         correct: 0,
    //     },

    //     {
    //         filename: "runtime_none.py",
    //         lines: [
    //             "user = None",
    //             "label = 'User name:'",
    //             "name = user.name",
    //             "output = label + str(name)",
    //             "print(output)",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "off_by_one.py",
    //         lines: [
    //             "nums = [10, 20, 30]",
    //             "count = len(nums)",
    //             "for i in range(count + 1):",
    //             "    value = nums[i]",
    //             "    print(value)",
    //             "print('Loop finished')",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "logical_operator.py",
    //         lines: [
    //             "def is_even(n):",
    //             "    remainder = n % 2",
    //             "    return remainder == 1",
    //             "value = 4",
    //             "print(is_even(value))",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "condition_bug.py",
    //         lines: [
    //             "def check_adult(age):",
    //             "    limit = 18",
    //             "    if age > limit:",
    //             "        return True",
    //             "    return False",
    //             "result = check_adult(18)",
    //             "print(result)",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "div_zero.py",
    //         lines: [
    //             "x = 10",
    //             "y = 0",
    //             "factor = 1",
    //             "result = x / y",
    //             "print('Result is:', result)",
    //         ],
    //         correct: 3,
    //     },

    //     {
    //         filename: "indent_error.py",
    //         lines: [
    //             "def say_hi():",
    //             "    text = 'Hi!'",
    //             "print(text)",
    //             "value = 1",
    //             "say_hi()",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "sum_bug.py",
    //         lines: [
    //             "def add(a, b):",
    //             "    total = a - b",
    //             "    return total",
    //             "x, y = 5, 3",
    //             "result = add(x, y)",
    //             "print('Sum is:', result)",
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "index_error.py",
    //         lines: [
    //             "arr = [1, 2, 3]",
    //             "length = len(arr)",
    //             "value = arr[5]",
    //             "print(value)",
    //             "print('Done')",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "sum_func.py",
    //         lines: [
    //             "def sum(a, b):",
    //             "    result = 0",
    //             "    return result",
    //             "x, y = 2, 3",
    //             "print(sum(x, y))",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "loop_bug.py",
    //         lines: [
    //             "nums = [1, 2, 3]",
    //             "total = len(nums)",
    //             "for i in range(total):",
    //             "    value = nums[i]",
    //             "print(value)",
    //         ],
    //         correct: 4,
    //     },

    //     {
    //         filename: "filter_bug.py",
    //         lines: [
    //             "nums = [1, 2, 3, 4]",
    //             "values = list(nums)",
    //             "evens = filter(lambda n: n % 2, values)",
    //             "result = list(evens)",
    //             "print(result)",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "file_read.py",
    //         lines: [
    //             "path = 'data.txt'",
    //             "f = open(path)",
    //             "data = f.read()",
    //             "size = len(data)",
    //             "print(size)",
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "compare_bug.py",
    //         lines: [
    //             "a = [1, 2, 3]",
    //             "b = a.copy()",
    //             "if a is b:",
    //             "    print('Same')",
    //             "else:",
    //             "    print('Different')",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "string_concat.py",
    //         lines: [
    //             "name = None",
    //             "label = 'Hello '",
    //             "message = label + name",
    //             "print(message)",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "dict_key_bug.py",
    //         lines: [
    //             "d = {'a': 1}",
    //             "key = 'b'",
    //             "value = d[key]",
    //             "print(value)",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "list_remove.py",
    //         lines: [
    //             "nums = [1, 2, 3]",
    //             "copy = list(nums)",
    //             "for n in copy:",
    //             "    nums.remove(n)",
    //             "print(nums)",
    //         ],
    //         correct: 3,
    //     },

    //     {
    //         filename: "none_check.py",
    //         lines: [
    //             "x = None",
    //             "value = 0",
    //             "if x == None:",
    //             "    print('None!')",
    //             "print(value)",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "dict_copy.py",
    //         lines: [
    //             "a = {'x': 1}",
    //             "b = a",
    //             "b['x'] = 2",
    //             "value = a['x']",
    //             "print(value)",
    //         ],
    //         correct: 1,
    //     },

    //     {
    //         filename: "loop_shadow.py",
    //         lines: [
    //             "sum = 0",
    //             "values = [1, 2, 3]",
    //             "for sum in values:",
    //             "    print(sum)",
    //             "print(sum)",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "compare_float.py",
    //         lines: [
    //             "a = 0.1 + 0.2",
    //             "b = 0.3",
    //             "result = a == b",
    //             "print(result)",
    //         ],
    //         correct: 2,
    //     },

    //     {
    //         filename: "list_default.py",
    //         lines: [
    //             "def add_to_list(val, lst=[]):",
    //             "    item = val",
    //             "    lst.append(item)",
    //             "    return lst",
    //             "print(add_to_list(1))",
    //             "print(add_to_list(2))",
    //         ],
    //         correct: 0,
    //     },

    //     {
    //         filename: "global_bug.py",
    //         lines: [
    //             "count = 0",
    //             "def inc():",
    //             "    value = 1",
    //             "    count += value",
    //             "    return count",
    //             "print(inc())",
    //         ],
    //         correct: 3,
    //     },

    //     {
    //         filename: "exception_bug.py",
    //         lines: [
    //             "try:",
    //             "    x = 1 / 0",
    //             "    print(x)",
    //             "except Exception:",
    //             "    pass",
    //             "print('Done')",
    //         ],
    //         correct: 1,
    //     },
    // ]

    python: [
        {
            filename: "mutable_default.py",
            lines: [
                "def append_item(item, lst=[]):",
                "    lst.append(item)",
                "    return lst",
                "result1 = append_item(1)",
                "result2 = append_item(2)",
                "print(result2)",
            ],
            correct: 0,
        },
        {
            filename: "syntax_error.py",
            lines: [
                "def greet(name)",
                "    print('Hello ' + name)",
                "greet('Alice')",
            ],
            correct: 0,
        },
        {
            filename: "runtime_none.py",
            lines: [
                "user = None",
                "name = user.name",
                "print('User name is:', name)",
            ],
            correct: 1,
        },
        {
            filename: "off_by_one.py",
            lines: [
                "nums = [10, 20, 30]",
                "for i in range(len(nums)+1):",
                "    print(nums[i])",
                "print('Loop finished')",
            ],
            correct: 1,
        },
        {
            filename: "logical_operator.py",
            lines: [
                "def is_even(n):",
                "    return n % 2 == 1",
                "print(is_even(4))",
            ],
            correct: 1,
        },
        {
            filename: "condition_bug.py",
            lines: [
                "def check_adult(age):",
                "    if age > 18:",
                "        return True",
                "    return False",
                "print(check_adult(18))",
            ],
            correct: 1,
        },
        {
            filename: "div_zero.py",
            lines: [
                "x = 10",
                "y = 0",
                "result = x / y",
                "print('Result is:', result)",
            ],
            correct: 2,
        },
        {
            filename: "indent_error.py",
            lines: [
                "def say_hi():",
                "print('Hi!')",
                "say_hi()",
            ],
            correct: 1,
        },
        {
            filename: "sum_bug.py",
            lines: [
                "def add(a, b):",
                "    return a - b",
                "result = add(5, 3)",
                "print('Sum is:', result)",
            ],
            correct: 1,
        },
        {
            filename: "index_error.py",
            lines: [
                "arr = [1, 2, 3]",
                "print(arr[5])",
                "print('Done')",
            ],
            correct: 1,
        },
        {
            filename: "sum_func.py",
            lines: [
                "def sum(a, b):",
                "    return 0",
            ],
            correct: 1,
        },
        {
            filename: "loop_bug.py",
            lines: [
                "nums = [1, 2, 3]",
                "    print(nums[i])",
            ],
            correct: 1,
        },
        {
            filename: "filter_bug.py",
            lines: [
                "nums = [1, 2, 3, 4]",
                "evens = filter(lambda n: n % 2, nums)",
            ],
            correct: 1,
        },
        {
            filename: "mutable_default.py",
            lines: [
                "def append_item(item, lst=[]):",
                "    lst.append(item)",
                "    return lst",
            ],
            correct: 0,
        },
        {
            filename: "file_read.py",
            lines: [
                "f = open('data.txt')",
                "data = f.read()",
            ],
            correct: 0,
        },
        {
            filename: "compare_bug.py",
            lines: [
                "if a is b.copy():",
                "    print('Same')",
            ],
            correct: 0,
        },
        {
            filename: "string_concat.py",
            lines: [
                "name = None",
                "print('Hello ' + name)",
            ],
            correct: 1,
        },
        {
            filename: "dict_key_bug.py",
            lines: [
                "d = {'a': 1}",
                "print(d['b'])",
            ],
            correct: 1,
        },
        {
            filename: "list_remove.py",
            lines: [
                "nums = [1, 2, 3]",
                "for n in nums:",
                "    nums.remove(n)",
            ],
            correct: 2,
        },
        {
            filename: "none_check.py",
            lines: [
                "x = None",
                "if x == None:",
                "    print('None!')",
            ],
            correct: 1,
        },
        {
            filename: "division_bug.py",
            lines: [
                "a, b = 5, 2",
                "print(a / b)",
            ],
            correct: 1,
        },
        {
            filename: "dict_copy.py",
            lines: [
                "a = {'x': 1}",
                "b = a",
                "b['x'] = 2",
                "print(a['x'])",
            ],
            correct: 2,
        },
        {
            filename: "sort_bug.py",
            lines: [
                "nums = [10, 2, 5]",
                "nums.sort()",
                "print(nums == [2, 5, 10])",
            ],
            correct: 1,
        },
        {
            filename: "loop_shadow.py",
            lines: [
                "sum = 0",
                "for sum in range(3):",
                "    print(sum)",
            ],
            correct: 1,
        },
        {
            filename: "join_bug.py",
            lines: [
                "words = ['a', 'b', 'c']",
                "print('-'.join(words))",
            ],
            correct: 1,
        },
        {
            filename: "compare_float.py",
            lines: [
                "a = 0.1 + 0.2",
                "if a == 0.3:",
                "    print('Equal')",
            ],
            correct: 1,
        },
        {
            filename: "strip_bug.py",
            lines: [
                "s = ' hello '",
                "print(s.strip())",
            ],
            correct: 1,
        },
        {
            filename: "list_default.py",
            lines: [
                "def add_to_list(val, lst=[]):",
                "    lst.append(val)",
                "    return lst",
            ],
            correct: 0,
        },
        {
            filename: "global_bug.py",
            lines: [
                "count = 0",
                "def inc():",
                "    count += 1",
            ],
            correct: 2,
        },
        {
            filename: "exception_bug.py",
            lines: [
                "try:",
                "    x = 1 / 0",
                "except Exception:",
                "    pass",
            ],
            correct: 2,
        },

    ]
};

export const errorCharacters = [
    {
        src: "/errors/hat.svg",
        side: "right",
        taunts: [
            // "Really?",
            // "Try harder!",
            // "Oops!",
            // "You are fired.",
            // "I would have solved it.",
            // "Classic mistake.",
            // "Took you long enough.",
            // "Do you even code?",
            // "One of us is doing great. It’s not you."
            "So close.",
            "Nearly perfect.",
            "Just one more step.",
            "You’re getting there.",
            "Almost got it.",
            "Just missed it.",
            "One small thing.",
            "Close call.",
            "Nearly."
        ],
    },
    {
        src: "/errors/magnifier.svg",
        side: "right",
        taunts: [
            // "Check again!",
            // "Think!",
            // "Hmm...",
            // "Let me debug that for you.",
            // "Have you tried thinking?",
            // "This is why I'm here.",
            // "I’m not mad, just disappointed.",
            // "Humans…",
            // "My turn."
            "So close.",
            "Nearly perfect.",
            "Just one more step.",
            "You’re getting there.",
            "Almost got it.",
            "Just missed it.",
            "One small thing.",
            "Close call.",
            "Nearly."
        ],
    },
    {
        src: "/errors/standing.svg",
        side: "left",
        taunts: [
            // "Nope!",
            // "Guess again!",
            // "Not quite!",
            // "That… was not it.",
            // "Even StackOverflow can’t save you.",
            // "Your keyboard must be tired from being wrong.",
            // "At this point, it's performance art.",
            // "I solve bugs. You *create* them."
            "So close.",
            "Nearly perfect.",
            "Just one more step.",
            "You’re getting there.",
            "Almost got it.",
            "Just missed it.",
            "One small thing.",
            "Close call.",
            "Nearly."
        ],
    },
    {
        src: "/errors/chair.svg",
        side: "left",
        taunts: [
            // "Close, but no!",
            // "Almost...",
            // "You sure?",
            // "You call that a solution?",
            // "I expected better.",
            // "Oof. Big oof.",
            // "Want me to handle it?",
            // "Try again, developer."
            "So close.",
            "Nearly perfect.",
            "Just one more step.",
            "You’re getting there.",
            "Almost got it.",
            "Just missed it.",
            "One small thing.",
            "Close call.",
            "Nearly."
        ],
    },
];